
import { ILayoutImage } from "@/utils/layout-editor";
import Vue from "vue";
import AppDraggableResizeCombo from "./DraggableResizeCombo.vue";

export default Vue.extend({
	props: {
		logo: Object as () => ILayoutImage,
	},
	computed: {
		imgUrl(): string {
			return this.logo.getImageUrl();
		},
		style():any {
			return {
				maxWidth: this.logo.Width + "mm",
				maxHeight: this.logo.Height + "mm"
			};
		},
	},
	components: {
		AppDraggableResizeCombo
	}
});
